import React from 'react';
import { Pagination, Filter, List, Edit, Create, SimpleForm, Datagrid, TextField, BooleanField, DateField, ReferenceField, DateInput, TextInput, BooleanInput, ReferenceInput, SelectInput, required } from 'react-admin';
import { stripedDataGridSx } from './styles/dataGridStyles';

const TruckFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
    </Filter>
);

const TruckPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />;

export const TruckList = props => (
    <List
        {...props}
        filters={<TruckFilter />}
        pagination={<TruckPagination />}
        bulkActionButtons={false}
    >
        <Datagrid rowClick="edit" sx={stripedDataGridSx}>
            <ReferenceField label="Order" source="OrderID" reference="orders">
                <TextField source="Order_Num" />
            </ReferenceField>
            <ReferenceField label="Trucking Company" source="CarrierID" reference="truckingcompanies">
                <TextField source="Trucking_Company" />
            </ReferenceField>
            <DateField source="Truck_Type" />
            <DateField source="PickUp_Date" />
            <DateField source="Delivery_Date" />
            <BooleanField source="Early_Delivery" />
            <TextField source="Rate_From_Freight_Carrier" />
            <TextField source="Special_Instructions" />
            <BooleanField source="Shipping_Documents" />
            <BooleanField source="Truck_Emailed_Truck_Docs" />
            <BooleanField source="Truck_Emailed_Mill_Docs" />
        </Datagrid>
    </List>
);

export const TruckEdit = props => (
    <Edit undoable={false} {...props}>
        <SimpleForm>
            <TextInput disabled source="id" />
            <ReferenceInput label="Order" source="OrderID" reference="orders" validate={[required()]}>
                <SelectInput optionText="Order_Num" />
            </ReferenceInput>
            <ReferenceInput label="Trucking Company" source="CarrierID" reference="truckingcompanies" validate={[required()]}>
                <SelectInput optionText="Trucking_Company" />
            </ReferenceInput>
            <DateInput source="Truck_Type" />
            <DateInput source="PickUp_Date" />
            <DateInput source="Delivery_Date" />
            <BooleanInput source="Early_Delivery" />
            <TextInput source="Rate_From_Freight_Carrier" />
            <TextInput source="Special_Instructions" />
            <BooleanInput source="Shipping_Documents" />
            <BooleanInput source="Truck_Emailed_Truck_Docs" />
            <BooleanInput source="Truck_Emailed_Mill_Docs" />
            <TextInput source="Truck_When_Emailed_Truck_Docs" />
            <TextInput source="Truck_When_Emailed_Mill_Docs" />
            <TextInput source="Source" />
        </SimpleForm>
    </Edit>
);

export const TruckCreate = props => (
    <Create {...props}>
        <SimpleForm redirect="list">
            <ReferenceInput label="Order" source="OrderID" reference="orders" validate={[required()]}>
                <SelectInput optionText="Order_Num" />
            </ReferenceInput>
            <ReferenceInput label="Trucking Company" source="CarrierID" reference="truckingcompanies" validate={[required()]}>
                <SelectInput optionText="Trucking_Company" />
            </ReferenceInput>
            <DateInput source="Truck_Type" />
            <DateInput source="PickUp_Date" />
            <DateInput source="Delivery_Date" />
            <BooleanInput source="Early_Delivery" />
            <TextInput source="Rate_From_Freight_Carrier" />
            <TextInput source="Special_Instructions" />
            <BooleanInput source="Shipping_Documents" />
            <BooleanInput source="Truck_Emailed_Truck_Docs" />
            <BooleanInput source="Truck_Emailed_Mill_Docs" />
            <TextInput source="Truck_When_Emailed_Truck_Docs" />
            <TextInput source="Truck_When_Emailed_Mill_Docs" />
            <TextInput source="Source" />
        </SimpleForm>
    </Create>
);
